import { NAMES_ROUTES } from "@/const/routes.constants"

export const DECISIONS_PATH = "decisions"

// The decisions' filters, kept in the url as the filter bar sets them: the
// policies they are narrowed to, their kinds, and the API's other filters by
// its own names
export const DECISIONS_POLICY_PARAM = "policy"
export const DECISIONS_POLICY_KIND_PARAM = "policyKind"
export const DECISIONS_FILTER_KEYS = [
  DECISIONS_POLICY_PARAM,
  DECISIONS_POLICY_KIND_PARAM,
  "platform",
  "agentId",
  "tool",
  "outcome",
  "enforcedBy"
] as const

// The page's tabs: the policies at the page's own path, the decisions under
// DECISIONS_PATH
export const AI_POLICIES_TABS = {
  POLICIES: "policies",
  DECISIONS: "decisions"
} as const

export const getDecisionsUrl = (policyId?: string) => {
  const { ROOT, AI } = NAMES_ROUTES.GOVERNANCE
  const url = `/${ROOT}/${AI}/${DECISIONS_PATH}`

  return policyId
    ? `${url}?${new URLSearchParams({ [DECISIONS_POLICY_PARAM]: policyId })}`
    : url
}
